import { SearchTextPaylod } from '../../models';
import { actionCreator } from '../common';
import { FilterActionTypes } from '../types';

export const filterActionCreator = {
  changeSearchText: actionCreator<SearchTextPaylod>(FilterActionTypes.CHANGE_SEARCH_TEXT),
};
